import { ByDate } from "./by-date";

export class RiderOrder {
    byDate:ByDate[]
}
